import type { BoatAd, SearchKey } from '../../types';

export function getBulletPointsText(ad: BoatAd, searchKey: SearchKey) {
    const showWidth = [
        'SEARCH_ID_BOAT_DOCK_WANTED',
        'SEARCH_ID_BOAT_DOCK',
    ].includes(searchKey);
    const showDealer = ['SEARCH_ID_BOAT_USED'].includes(searchKey);

    let output: string[] = [];
    if (showDealer && ad.dealer_segment)
        output = output.concat(ad.dealer_segment);
    if (ad.motor_fuel) output = output.concat(ad.motor_fuel);
    if (ad.motor_type) output = output.concat(ad.motor_type);
    if (ad.max_speed) output = output.concat(ad.max_speed + ' knop');
    if (showWidth && ad.width) output = output.concat(ad.width + ' cm');

    return output.join(' ∙ ');
}
